import { useEffect, useState } from 'react'
import { CommonModals, YooKassaStage } from '../../../../../../common/types/enums'
import { setCommonModalState } from '../../../../../../store/slices/commonModalSlice'
import { useDispatch } from 'react-redux'
import { getApi } from '../../../../../../api/api'
import { useRefresh } from '../../../../../../common/hooks/useRefresh'

export const useYooKassa = (yoomoneyToken: string, paymentId: string) => {
  const dispatch = useDispatch()
  const [api] = useState(getApi())
  const [stage, setStage] = useState<YooKassaStage>(YooKassaStage.WIDGET)
  const { refresh } = useRefresh()
  const setPaymentModalState = (state: boolean) =>
    dispatch(setCommonModalState({ modal: CommonModals.PAYMENT, state }))
  const [checkout] = useState(
    //@ts-ignore
    new window.YooMoneyCheckoutWidget({
      confirmation_token: yoomoneyToken,
      customization: {
        // payment_methods: ['sbp', 'bank_card', 'yoo_money', 'sberbank']
      },
      error_callback: function (error: any) {},
    }),
  )

  const finishPayment = async () => {
    try {
      await api.closePayment({ id: paymentId })
    } catch (error) {}
  }

  checkout.on('success', async () => {
    if (paymentId) await finishPayment()
    await refresh()
    if (checkout.destroy) checkout.destroy()
    setStage(YooKassaStage.SUCCESS)
    setTimeout(() => {
      setPaymentModalState(false)
    }, 3000)
  })

  checkout.on('fail', () => {
    checkout.destroy && checkout.destroy()
    setStage(YooKassaStage.ERROR)
    setTimeout(() => {
      setPaymentModalState(false)
    }, 30000)
  })

  useEffect(() => {
    return () => {
      if (checkout && checkout.destroy) checkout.destroy()
    }
  }, [])

  useEffect(() => {
    if (yoomoneyToken !== 'empty_token') {
      checkout
        .render('payment_form')
        //Метод возвращает Promise, исполнение которого говорит о полной загрузке платежной формы (можно не использовать).
        .then(() => {
          //Код, который нужно выполнить после отображения платежной формы.
        })
    }
  }, [yoomoneyToken])

  return { stage }
}
